import type { RiskItem } from "./risk.type";

import { capitalize } from "@/utilities/string";

export const riskDisplayLabel = (risk?: RiskItem) => {
  if (!risk) return "";

  const name = capitalize(risk.name ?? "");

  if ("weight" in risk && risk.weight) {
    return `${name} (${risk.weight})`;
  }

  return name;
};
